import script from "./ExhibitHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitHeader.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitHeader.vue?vue&type=style&index=0&id=00cab642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cab642"]])

export default __exports__